export default __webpack_public_path__ + "img/cEgbwuEB.308264e3.svg";